<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
    class="m-initial-loading"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
    v-else
    class="m-card-primary m-the-modal-content m-edition-billing-my-payments-change-plan-modal-pay-methods">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="cambioPlan()"
    >
      <header class="m-the-modal-header">
        <h5> {{ $t('mEditionBillingMyPaymentModalPaymentMethods.header.title') }} </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section-height-auto">
        <p
          v-for="pasarela in gateways"
          :key="pasarela.id_academia_pasarela_pago"
          class="margin-bottom-large margin-top-large"
        >
          <label class="display-flex-row a-radiobutton-primary a-radiobutton-billing-primary width-100-pr">
            <input
              v-model="$modal.element.pasarela"
              class="a-radiobutton-primary a-radiobutton-billing-primary"
              name="medioPago"
              type="radio"
              :value="pasarela.id_academia_pasarela_pago"
            >
            <span class="a-radiobutton-checkmark"></span>
            <span class="margin-left-xsmall">
              {{ findGatewayById(pasarela.pasarela_pago).nombre_publico }}
            </span>
            <span class="margin-left-auto">
              <img
                :alt="findGatewayById(pasarela.pasarela_pago).nombre"
                :src="require(`@/assets/img/gateways/${findGatewayById(pasarela.pasarela_pago).nombre.toLowerCase().replace(' ', '')}.png`)"
              >
            </span>
          </label>
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionBillingMyPaymentModalPaymentMethods.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary.confirmar"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsModalChangePaymentMethod',
  data () {
    return {
      buttonPrimary: {
        confirmar: {
          action: this.$t('mEditionBillingMyPaymentModalPaymentMethods.buttonPrimary'),
          class: 'a-button-billing-primary',
          sending: false,
          type: 'submit'
        }
      },

      pasarelas: [],

      pasarelaSelected: null,

      showLoadingState: 0
    }
  },

  computed: {
    gateways () {
      return [...this.$modal.element.gateways]
    }
  },

  created () {
    this.readPasarelas()
  },

  methods: {
    cambioPlan () {
      this.buttonPrimary.confirmar.sending = true
      this.$services.create('ventas', 'changePlan', {
        academia: this.$store.getters.getAcademyData.id,
        producto: this.$modal.element.producto,
        plan: this.$modal.element.plan,
        pasarela: this.$modal.element.pasarela
      }, [ this.$modal.element.venta ])
        .then(response => {
          this.$utils.isUrl(response.data)
            ? window.location.replace(response.data)
            : this.findGatewayById(this.$modal.element.gateways.find(pp => pp.id_academia_pasarela_pago === this.$modal.element.pasarela).pasarela_pago).nombre === 'Paypal'
              ? this.$paypal.formPaypal(JSON.parse(response.data))
              : this.$stripe.init(Object.assign(
                {},
                { stripeAccount: this.$modal.element.gateways.find(pp => pp.id_academia_pasarela_pago === this.$modal.element.pasarela).configuracion['id'] },
                { sessionId: response.data })
              )
          this.buttonPrimary.confirmar.sending = false
          this.$modal.closeModal()
          this.showLoadingState++
        })
        .catch(error => {
          this.showLoadingState++
          this.$alerts.pushAlert('mEditionBillingMyPaymentModalChangePlan', 'changePlan', 'error', 'a-alert-danger')
          this.buttonPrimary.confirmar.sending = false
          this.$modal.closeModal()
          console.log(error)
        })
    },

    findGatewayById (id) {
      return this.pasarelas.find(gw => gw.id === id)
    },

    readPasarelas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelas = response.data
          this.pasarelaSelected = this.$modal.element.pasarela
            ? this.pasarelas.find(p => { return p.nombre === this.$modal.element.pasarela }).id
            : null
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
